import { useContext } from 'react';
import {
  BreadcrumbsContext,
  BreadcrumbsContextValue,
} from './breadcrumbs-context';

export const useBreadcrumbs = (): BreadcrumbsContextValue => {
  const context = useContext(BreadcrumbsContext);

  if (context === undefined) {
    throw new Error('useBreadcrumbs must be used within a BreadcrumbsProvider');
  }

  return context;
};
